export type PriorityLevelValues = 'NO' | 'YES' | 'PRIORITY';

export const priorityLevels: PriorityLevelValues[] = ['NO', 'PRIORITY', 'YES'];

export enum MENTEE_PRIORITY_LEVELS {
  NO = 'Pas vraiment',
  YES = 'Oui',
  PRIORITY = 'Prioritaire',
}

export enum MENTOR_PRIORITY_LEVELS {
  NO = 'Plutôt pas',
  YES = 'Oui si besoin',
  PRIORITY = 'Oui avec plaisir',
}
